<script setup lang="ts">
  const { activeBreakpoint } = useDeviceType();
  const isDesktop = computed(() => ['lg', 'xl', '2xl', '3xl'].includes(activeBreakpoint.value));
</script>

<template>
  <section
    id="revshare-section"
    class="relative w-full min-h-[31.25rem] rounded-10px overflow-hidden lg:min-h-auto desktop-1660:max-h-[15.75rem] lg:overflow-hidden"
  >
    <template v-if="isDesktop">
      <NuxtImg
        class="absolute inset-0 z-0 w-full h-full pointer-events-none"
        src="/images/lo-hp-new/affiliates-bg-desktop.webp"
        densities="x1 x2"
        format="webp"
        alt="affiliates-bg-desktop"
        loading="lazy"
        fit="fill"
      />

      <div class="relative grid grid-cols-[56%_auto] text-left text-white">
        <div class="p-10 flex flex-col gap-4 font-barlow">
          <h2 class="text-[2.375rem] font-extrabold leading-[130%] uppercase">
            JOIN AND EARN
            <br class="desktop-1660:hidden" />
            <i class="text-[#5BB5FA] text-[2.875rem] italic font-black">UP TO 50%</i>
            REVSHARE
          </h2>
          <p class="text-xl not-italic font-medium leading-[135%]">
            Earn money by joining the MaxDuel Affiliate Program. You’ll receive a commission for every player who
            registers and plays through your referral links.
          </p>
          <CoreButton color="green" class="h-[3.125rem] w-full max-w-[16.25rem]" @click="stores.modals.showSignUpModal">
            <span class="text-white text-center font-inter text-base not-italic font-bold leading-none uppercase">
              START EARNING NOW
            </span>
          </CoreButton>
        </div>
        <div class="relative lg:-translate-x-6 desktop-1660:translate-0">
          <NuxtImg
            class="absolute top-1/2 -translate-y-1/2 w-full aspect-[1474/875] max-w-[44.625rem] mx-auto"
            src="/images/lo-hp-new/affiliates-art-desktop.webp"
            densities="x1 x2"
            format="webp"
            loading="lazy"
            alt="affiliates-art-desktop"
          />
        </div>
      </div>
    </template>

    <template v-else>
      <NuxtImg
        class="absolute inset-0 z-0 w-full pointer-events-none h-full"
        src="/images/lo-hp-new/affiliates-bg-mobile.webp"
        densities="x1 x2"
        format="webp"
        alt="affiliates-bg-mobile"
        loading="lazy"
        fit="fill"
      />
      <NuxtImg
        class="relative w-full aspect-[381/310] max-w-[460px] mx-auto"
        src="/images/lo-hp-new/affiliates-art-mobile.webp"
        densities="x1 x2"
        format="webp"
        loading="lazy"
        alt="affiliates-art-mobile"
      />
      <div
        class="absolute inset-0 flex flex-col items-center justify-end gap-3 px-3 pb-4 text-left text-white font-barlow min-[37.5rem]:text-center"
      >
        <div class="w-full">
          <h2 class="w-full text-[1.5879rem] not-italic font-extrabold leading-none">
            <span>JOIN US AND EARN</span>
            <br />
            <i class="text-[#5BB5FA] text-[2.504rem] italic font-black leading-none">UP TO 50%</i>
            REVSHARE
          </h2>
        </div>
        <p class="w-full text-white/80 text-base not-italic leading-[135%]">
          Earn money by joining the MaxDuel Affiliate Program.
          <br class="hidden min-[37.5rem]:block" />
          You’ll receive a commission for every player
          <br class="hidden min-[37.5rem]:block" />
          who registers and plays through your referral links.
        </p>
        <CoreButton color="green" class="h-12 w-full max-w-[26.25rem]" @click="stores.modals.showSignUpModal">
          <span class="text-white text-center font-inter text-[0.855rem] not-italic font-bold leading-none uppercase">
            START EARNING NOW
          </span>
        </CoreButton>
      </div>
    </template>
  </section>
</template>
